import React from 'react'

import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'

import Coin from 'components/Coin'
import GameCardScores from '../GameCardScores'

interface Props {
  size: number
  score: number
  winnings: number
}

const styles = createStyles({
  value: {
    fontSize: 16,
    fontWeight: 500,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const GameCardScoresCompleted: React.SFC<InjectedProps> = ({
  classes,
  size,
  score,
  winnings,
}) => {
  return (
    <GameCardScores
      columns={[{
        value: (
          <Typography className={classes.value}>
            {size}
          </Typography>
        ),
        label: '# of players'
      }, {
        value: (
          <Typography className={classes.value}>
            {score}
          </Typography>
        ),
        label: 'points',
      }, {
        value: (
          <Coin className={classes.value} value={winnings} withPrefix />
        ),
        label: 'payout',
      }]}
      rounded
    />
  )
}

export default withStyles(styles)(GameCardScoresCompleted)
